import { createSlice } from "@reduxjs/toolkit";
import { NotificationDurationMs, NotificationType } from "./types";
const initialState = {
    salesBannerDisabled: false,
    message: "",
    title: undefined,
    type: NotificationType.success,
    isVisible: false,
    duration: NotificationDurationMs.normal,
};
const notificationSlice = createSlice({
    name: "notification",
    initialState,
    reducers: {
        setDisabledSalesBanner: (state, action) => {
            state.salesBannerDisabled = action.payload;
        },
        displayNotification: (state, action) => {
            state.message = action.payload.message;
            state.title = action.payload.title;
            state.type = action.payload.type;
            state.isVisible = true;
            state.duration = action.payload.duration;
        },
        hideNotification: (state) => {
            state.isVisible = false;
        },
    },
});
export const { setDisabledSalesBanner, displayNotification, hideNotification } = notificationSlice.actions;
export default notificationSlice.reducer;
